import {autobind} from "core-decorators";
import {action, observable} from "mobx";

import Apollo from "./Apollo";
import StageStore from "./StageStore";
import History from "./History";
import Session from "./Session";

@autobind
export default class Store {
  @observable alert?: React.ReactNode;

  // stores
  @observable stageStore = new StageStore();
  @observable apollo = new Apollo(this.stageStore);
  @observable session = new Session(this.apollo, this.stageStore);
  @observable history = new History(this.session);

  @action
  setAlert(component?: React.ReactNode) {
    this.alert = component;
  }
}
